"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M14.364 14C12.537 14 9.969 11.486 9.472 10.981C8.416 9.91 6.527 8.4 5.636 8.4C4.433 8.4 3.455 9.342 3.455 10.5C3.455 11.658 4.433 12.6 5.636 12.6C5.795 12.6 6.236 12.535 7.098 11.979C7.262 11.873 7.484 11.906 7.6 12.06L8.027 12.625C8.147 12.784 8.106 13.014 7.937 13.124C7.031 13.713 6.276 14 5.636 14C3.632 14 2 12.43 2 10.5C2 8.57 3.632 7 5.636 7C7.463 7 10.031 9.515 10.528 10.019C11.585 11.091 13.474 12.6 14.364 12.6C15.567 12.6 16.546 11.658 16.546 10.5C16.546 9.342 15.567 8.4 14.364 8.4C14.205 8.4 13.764 8.465 12.903 9.021C12.738 9.127 12.516 9.095 12.4 8.94L11.973 8.375C11.853 8.216 11.894 7.987 12.063 7.876C12.969 7.287 13.724 7 14.364 7C16.369 7 18 8.57 18 10.5C18 12.43 16.369 14 14.364 14Z",
    fill: "#727B7F"
  }));
};